import styled from 'styled-components'
import { colors } from '@/styles/colors'
import { fontStyles, fontWeight } from '@/styles/fonts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type Props = {
  text: string
  labelColor?: string
  disabled?: boolean
  extraMarginLeft?: boolean
}

const ExternalSellerContainer = styled.span<{
  labelColor?: string
  disabled: boolean
  extraMarginLeft?: boolean
}>`
  ${fontStyles.body.sm}
  font-weight: ${fontWeight.bold};
  padding: 1rem 6rem;
  background-color: ${({ disabled }) => (disabled ? colors.gray10 : colors.gray25)};
  color: ${(props) => (props.labelColor ? props.labelColor : colors.white)};
  border-radius: 4rem 0;
  display: inline-block;
  display: flex;
  align-items: center;
  gap: 4rem;
  margin-left: ${({ extraMarginLeft }) => (extraMarginLeft ? '33rem' : '0')};

  svg {
    width: 14rem;
    height: 14rem;
  }
`

const ExternalSeller = ({ text, labelColor, disabled = false, extraMarginLeft = false }: Props) => {
  if (!text) {
    return null
  }

  return (
    <ExternalSellerContainer
      labelColor={labelColor}
      disabled={disabled}
      extraMarginLeft={extraMarginLeft}
    >
      <FontAwesomeIcon icon={['fas', 'triangle-exclamation']} />
      Verkoop door {text}
    </ExternalSellerContainer>
  )
}

export default ExternalSeller
